// removed by extract-text-webpack-plugin
module.exports = {"loading":"theme__loading___3XxVw"};


//////////////////
// WEBPACK FOOTER
// ./client/modules/ui/components/Loading/theme.scss
// module id = 1242
// module chunks = 0